import styled, { css } from "styled-components";

export const StyledIconWrap = styled.span`
    display: inline-flex;
    align-items: center;
    & > svg {
        transition: 0.2s;
        transform-origin: center;
        transform: ${({ transformRotate }) => `rotate(${transformRotate}deg)`};
        ${({ customStyle }) => customStyle && customStyle};
    }
    ${({ align }) => align === 'left' && css`
        margin-right: auto;
    `};
    ${({ align }) => align === 'center' && css`
        margin-left: auto;
        margin-right: auto;
    `};
    ${({ align }) => align === 'right' && css`
        margin-left: auto;
    `};
`;
